import { memo } from "react"
import "../index.scss";
import CustomScroll from '@src/component/customScroll';
import BottomIcon from "@src/component/bottomIcon";
import { goto } from "@src/route";
import { preSubmitInsured } from "@src/service/ownService";
import { Toast } from "antd-mobile";

const StateSucc = () => {

  const toBankCard =async () => {
    try{
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false
      })
      const res:any = await preSubmitInsured();
      Toast.clear()
      goto(`/apply/w1?loanId=${res.loanId?encodeURIComponent(res.loanId): '' }&no=${res.no as string}`);
    }catch(err:any){
      Toast.show(err?.errmsg);
    } 
  }

  return (
    <div className="page bottomFit rzStatus">
      <CustomScroll>
        <div className="reSuccess">
          <div className="successIcon" />
          <p>恭喜，您的资格预审已通过，<br></br>赶快填写融租资料吧！</p>
        </div>
      </CustomScroll>
      <footer>
        <div onClick={toBankCard} className="button-them upload-next">
          去申请融租购车
        </div>
        <BottomIcon/>
      </footer>
    </div>

  )
}

export default memo(StateSucc);